import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface service {
    name: string,
    api: string,
}

interface route {
    name: string,
    params?: {[k: string]: any},
    query?: {[k: string]: any}
}

@Component
/**
 * ProfileWishlist Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * Product Single Route
     */
    @Prop({ default: () => ({ name: 'products-single' }) }) productSingleRoute!: route;

    /**
     * Wishlist Item Service
     */
    @Prop({ default: () => ({ name: 'Relation', api: 'favouritesList' }) }) favouritesListService!: service;

    /**
     * Wishlist Remove Item Service
     */
    @Prop({ default: () => ({ name: 'Relation', api: 'favouritesChange' }) }) removeItemService!: service;
}
